import Cookies from 'js-cookie'
import { setupSlider } from '../components/slider'

const SELECTORS = Selectors({
  globalAlertsContainer: 'global-alerts-container',
  globalAlertsClose: 'global-alerts-close-button'
})

const $globalAlertsContainer = document.querySelector(SELECTORS.asClass('globalAlertsContainer'))
const $globalAlertsClose = document.querySelector(SELECTORS.asClass('globalAlertsClose'))

const fn = {
  init: () => {
    if ($globalAlertsContainer) {
      const $slider = $globalAlertsContainer.querySelector('.global-alerts-slider')

      const opts = {
        fade: true,
        prevNextButtons: false,
        pageDots: false,
        pauseAutoPlayOnHover: true,
        wrapAround: false
      }

      if ($slider.dataset.slider !== undefined) {
        const slider = setupSlider($slider, opts)

        setTimeout(() => {
          $($globalAlertsContainer).slideDown(() => {
            slider.resize()
          })
        }, 500)
      } else {
        setTimeout(() => {
          $($globalAlertsContainer).slideDown()
        }, 500)
      }

      $globalAlertsClose.addEventListener('click', () => {
        $($globalAlertsContainer).slideUp(() => {
          const inOneHour = 1/24
          Cookies.set('seenglobalalert', true, { expires: inOneHour })
        })
      })
    }
  }
}

export default {
  can: () => $globalAlertsContainer,
  run: fn.init
}
